import React, { useState, useRef } from 'react';
import BaseModel from "../../BaseModal"
import { FlexWrapperCenter, GapView } from '../../styles/WrapperStyles';
import { BaseButton } from '../../styles/ButtonStyles';
import styled, { css } from 'styled-components';
import placeholder_image from '../../assests/placeholder_image.png';
import { getSafeMediaUrl } from "../../utils";

const ImageWrapperDiv = styled.div`
  width: 100%;
  height: 243px;
  border-radius: 13px;
  /* margin-right: 20px; */
  ${props =>
    props.is_end &&
    css`
      margin-right: 0px;
    `}
  ${props =>
    props.rectangle &&
    css`
      height: 283px;
    `}
  ${props =>
    props.height &&
    css`
      height: ${props.height};
    `}
  background-color: #d7d7d7;
  max-width: 243px;
  align-items:center;
  justify-content : center
  display : flex
  position: relative;
`;

const ImageDivView = styled.img`
  width: 100%;
  max-width: 243px;
  height: 243px;
  border-radius: 13px;
  /* margin-right: 20px; */
  object-fit: cover;
  ${props =>
    props.is_end &&
    css`
      margin-right: 0px;
    `}
  background-color: #d7d7d7;
  ${props =>
    props.rectangle &&
    css`
      height: 283px;
    `}
  ${props =>
    props.height &&
    css`
      height: ${props.height};
    `}
`;

const VerifyModal = (props) => {

  const handleClose = () => {
    props.closeModal();
  };


  return (
    <BaseModel closeModal={handleClose}>
      <FlexWrapperCenter>
        <ImageWrapperDiv>
          <ImageDivView src={getSafeMediaUrl(props.image, placeholder_image)} alt="profile" onError={(e) => e.target.src = placeholder_image} />
        </ImageWrapperDiv>

      </FlexWrapperCenter>
      {props.hide_buttons && props.closeModal && (
        <div>
          <GapView height="20px" />
          <FlexWrapperCenter>
            <BaseButton onClick={props.closeModal}>Close</BaseButton>
          </FlexWrapperCenter>
        </div>
      )}
      {!props.hide_buttons && (
        <div>
          <GapView height="20px" />
          <FlexWrapperCenter>
            <BaseButton onClick={() => props.verify('verify')}>Verify</BaseButton>
          </FlexWrapperCenter>
          <GapView height="10px" />
          <FlexWrapperCenter>
            <BaseButton onClick={() => props.verify('remove')}>Unverify</BaseButton>
          </FlexWrapperCenter>
        </div>
      )}
    </BaseModel>
  );
};

export default VerifyModal;
